import { AppState } from '..';

export const selectApiState = (state: AppState) => state.api;
